import React, { useEffect, useState } from 'react'
import Layout from '../layout/Layout'
import { Nav, Tab } from 'react-bootstrap'
import ScrollingTab from '../components/ScrollingTab';
import MyEditor from '../components/MyEditor';
import { editPrivacyPolicy, getPrivacyPolicy } from '../controller';
import { requestHandler } from '../helper';
import { toast } from 'react-toastify';
import Loader from '../components/Loader';

function PrivacyPolicyAdmin() {
  const [isEditing, setIsEditing] = useState(false);
  const [activeTab, setActiveTab] = useState("annexA");

  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    annexA: { content: '', _id: '' },
    annexB: { content: '', _id: '' }
  });

  const getTermsData = async () => {
    await requestHandler(
      async () => await getPrivacyPolicy(true),
      setLoading,
      (res) => {
        setFormData({
          annexA: res.data.find(item => item.type === 0) || { content: '', _id: '' },
          annexB: res.data.find(item => item.type === 1) || { content: '', _id: '' }
        });
      },
      () => { }
    );
  };

  useEffect(() => {
    getTermsData();
  }, []);

  useEffect(() => {
    document.title = "Always Outdoors | Privacy Policy";
  }, []);

  const handleContentChange = (content) => {
    setFormData(prev => ({
      ...prev,
      [activeTab]: { ...prev[activeTab], content }
    }));
  };

  const handleEditButtonClick = async () => {
    if (isEditing) {
      await requestHandler(
        async () => await editPrivacyPolicy({ content: formData[activeTab].content }, formData[activeTab]._id),
        setLoading,
        (res) => {
          toast.success(res.message);
          getTermsData();
          setIsEditing(false);
        },
        () => { }
      );
    } else {
      setIsEditing(true);
    }
  }

  return (
    <>
      {loading && <Loader />}
      <Layout>
        <div className="card-wrapper">
          <div className="card-body">
            <Tab.Container id="dashboardTab" activeKey={activeTab} onSelect={(key) => setActiveTab(key)}>
              <ScrollingTab>
                <Nav className='theme-tab'>
                  <Nav.Item>
                    <Nav.Link eventKey="annexA">Annex A</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="annexB">Annex B</Nav.Link>
                  </Nav.Item>
                </Nav>
              </ScrollingTab>
              <Tab.Content className='mt-3'>
                <Tab.Pane eventKey="annexA">
                  <div className='d-flex justify-content-end'>
                    <button
                      className='btn btn-primary mb-3'
                      onClick={handleEditButtonClick}
                    >
                      {isEditing ? 'Save Changes' : 'Edit Policy'}
                    </button>
                  </div>
                  {!isEditing ? (
                    <div
                      className="privacy-policy-content"
                      dangerouslySetInnerHTML={{ __html: formData.annexA.content }}
                    />
                  ) : (
                    <MyEditor
                      content={formData.annexA.content}
                      onChange={handleContentChange}
                    />
                  )}
                </Tab.Pane>
                <Tab.Pane eventKey="annexB">
                  <div className='d-flex justify-content-end'>
                    <button
                      className='btn btn-primary mb-3'
                      onClick={handleEditButtonClick}
                    >
                      {isEditing ? 'Save Changes' : 'Edit Policy'}
                    </button>
                  </div>
                  {!isEditing ? (
                    <div
                      className="privacy-policy-content"
                      dangerouslySetInnerHTML={{ __html: formData.annexB.content }}
                    />
                  ) : (
                    <MyEditor
                      content={formData.annexB.content}
                      onChange={handleContentChange}
                    />
                  )}
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </Layout>
    </>
  )
}

export default PrivacyPolicyAdmin